// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2NP_c","col":"CardReaderDesc_col__sev71","label":"CardReaderDesc_label__3P_4P"};